import actionTypePrefixes from "./actionTypePrefixes"
import { ENVIRONMENT } from "../../constants"

/* eslint-disable import/prefer-default-export */
// Remove eslint comment above if we add more actions (as expected)

export function loadDummyData() {
  return {
    type: `${actionTypePrefixes.CustomReport}DUMMY_DATA`,
  }
}

export function loadDummyReviewData() {
  return {
    type: `${actionTypePrefixes.CustomReport}DUMMY_REVIEW_DATA`,
  }
}

export function loadDashboardData() {
  const apiUrl = "/custom-reports/get-custom-report-options"

  if (!ENVIRONMENT.useDummyData()) {
    return {
      type: `${actionTypePrefixes.CustomReport}LOAD_DASHBOARD_DATA`,
      payload: {
        request: {
          url: apiUrl,
        },
      },
    }
  }

  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch(loadDummyData())
      resolve()
    })
}

export function loadReviewData(reviewId) {
  const apiUrl = `/custom-reports/get-form-details?reviewId=${reviewId}`

  if (!ENVIRONMENT.useDummyData()) {
    return {
      type: `${actionTypePrefixes.CustomReport}LOAD_REVIEW_DATA`,
      payload: {
        request: {
          url: apiUrl,
        },
      },
    }
  }

  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch(loadDummyReviewData())
      resolve()
    })
}

export function refreshSubmittedReportList(triggeredByInterval) {
  const apiUrl = "/custom-reports/get-submitted-reports"

  if (!ENVIRONMENT.useDummyData()) {
    return {
      type: `${actionTypePrefixes.CustomReport}REFRESH_SUBMITTED_REPORT_DATA`,
      isAutoRefresh: triggeredByInterval,
      payload: {
        request: {
          url: apiUrl,
        },
      },
    }
  }

  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch(loadDummyReviewData())
      resolve()
    })
}

export function employeeSearch(searchString) {
  const apiUrl = `/custom-reports/employee-search?searchString=${searchString}`

  return {
    type: `${actionTypePrefixes.CustomReport}EMPLOYEE_SEARCH`,
    payload: {
      request: {
        url: apiUrl,
      },
    },
  }
}

export function resetEmployeeSearch() {
  return { type: `${actionTypePrefixes.CustomReport}EMPLOYEE_SEARCH_RESET` }
}

export function resetReportSelection() {
  return { type: `${actionTypePrefixes.CustomReport}RESET_REPORT_SELECTION` }
}

export function submitReport(data) {
  const apiUrl = "/custom-reports/add-export-request"

  return {
    type: `${actionTypePrefixes.CustomReport}SUBMIT_CUSTOM_REPORT`,
    payload: {
      request: {
        method: "POST",
        url: apiUrl,
        data: {
          ReportType: data.reportType,
          ReviewId: data.reviewId,
          ProcessStatus: 0,
          IncludeLeavers: data.includeLeavers,
          Sheets: data.sheets,
          EmployeeDetails: data.employeeDetails,
          Scopes: data.scopes,
          CultureCode: data.cultureCode,
        },
      },
    },
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/customReportApiActions.js